// alphabetized
import attachments from "./attachments";
import badges from "./badges";
import companies from "./companies";
import companyCompletionScores from "./company_completion_scores";
import companyJobs from "./company_jobs";
import companyRepresentations from "./company_representations";
import comments from "./comments";
import contactInfos from "./contact_infos";
import conversations from "./conversations";
import conversationsMailbox from "./conversations_mailbox";
import engagement from "./engagement";
import expertCompletionScores from "./expert_completion_scores";
import experts from "./experts";
import favoriteGroups from "./favorite_groups";
import feedPosts from "./feed_posts";
import follows from "./follows";
import hashtags from "./hashtags";
import messages from "./messages";
import mediaItems from "./media_items";
import mediaJobs from "./media_jobs";
import mediaOutlets from "./media_outlets";
import mediaProfiles from "./media_profiles";
import notifications from "./notifications";
import pitches from "./pitches";
import pitchReplies from "./pitch_replies";
import prProfileCompletionScores from "./pr_profile_completion_scores";
import prProfiles from "./pr_profiles";
import productCompletionScores from "./product_completion_scores";
import products from "./products";
import profileFeeds from "./profile_feeds";
import promoEntities from "./promo_entities";
import publicPitches from "./public_pitches";
import quotes from "./quotes";
import representations from "./representations";
import reporterMutes from "./reporter_mutes";
import reports from "./reports";
import userProfiles from "./user_profiles";
import requests from "./requests";
import users from "./users";

// qapi = "Qwoted API"
const qapi = {};

// alphabetized
qapi.attachments = attachments;
qapi.badges = badges;
qapi.companies = companies;
qapi.companyCompletionScores = companyCompletionScores;
qapi.companyJobs = companyJobs;
qapi.companyRepresentations = companyRepresentations;
qapi.comments = comments;
qapi.contactInfos = contactInfos;
qapi.conversations = conversations;
qapi.conversationsMailbox = conversationsMailbox;
qapi.engagement = engagement;
qapi.expertCompletionScores = expertCompletionScores;
qapi.experts = experts;
qapi.favoriteGroups = favoriteGroups;
qapi.feedPosts = feedPosts;
qapi.follows = follows;
qapi.hashtags = hashtags;
qapi.messages = messages;
qapi.mediaItems = mediaItems;
qapi.mediaJobs = mediaJobs;
qapi.mediaOutlets = mediaOutlets;
qapi.mediaProfiles = mediaProfiles;
qapi.notifications = notifications;
qapi.pitches = pitches;
qapi.pitchReplies = pitchReplies;
qapi.prProfileCompletionScores = prProfileCompletionScores;
qapi.prProfiles = prProfiles;
qapi.productCompletionScores = productCompletionScores;
qapi.products = products;
qapi.profileFeeds = profileFeeds;
qapi.promoEntities = promoEntities;
qapi.publicPitches = publicPitches;
qapi.quotes = quotes;
qapi.representations = representations;
qapi.reporterMutes = reporterMutes;
qapi.reports = reports;
qapi.userProfiles = userProfiles;
qapi.requests = requests;
qapi.users = users;

export default qapi;
